// src/App.js
import React, {lazy, Suspense, useEffect} from "react";
import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import "./App.scss";
import Main from "./containers/Main";
import Loading from "./containers/loading/Loading";
import {initVisitorTracking} from "./analytics/visitorTracker";
import {provideWebMcpContext} from "./agentDiscovery/webMcp";

const AdminVisitsPage = lazy(() => import("./components/admin/AdminVisitsPage"));
const ProjectsIndex = lazy(() =>
  import("./containers/projectPage/ProjectsIndex")
);
const ProjectPage = lazy(() => import("./containers/projectPage/ProjectPage"));
const AboutPage = lazy(() => import("./containers/about/About"));

function App() {
  useEffect(() => {
    const cleanupTracking = initVisitorTracking();
    const cleanupWebMcp = provideWebMcpContext();
    return () => {
      if (typeof cleanupTracking === "function") {
        cleanupTracking();
      }
      if (typeof cleanupWebMcp === "function") {
        cleanupWebMcp();
      }
    };
  }, []);

  return (
    <Router>
      <Suspense fallback={<Loading />}>
        <Switch>
          <Route exact path="/" component={Main} />
          <Route exact path={["/about", "/about/"]} component={AboutPage} />
          <Route
            exact
            path={["/projects", "/projects/"]}
            component={ProjectsIndex}
          />
          <Route path="/projects/:slug" component={ProjectPage} />
          <Route path="/admin/visits" component={AdminVisitsPage} />
        </Switch>
      </Suspense>
    </Router>
  );
}

export default App;
